import axios from 'axios'

export default class FormDataHandler {
  sendFormData(formData, sendResponse) {
    if (!formData) {
      sendResponse({ success: false })
      return
    }

    const partOneInComplete = Object.keys(formData[0]).length == 0
    const partTwoInComplete = Object.keys(formData[1]).length == 0
    const partThreeInComplete = Object.keys(formData[2]).length == 0

    if (partOneInComplete || partTwoInComplete || partThreeInComplete) {
      sendResponse({ success: false })
      return
    }

    const requestParams = {
      marketingemail: formData[0].email,
      name: formData[0].firstName,
      middlename: formData[0].middleName,
      lastname: formData[0].lastName,
      dob: formData[0].dob,
      homephone: formData[0].homePhone,
      mobile: formData[0].mobile,
      email: formData[0].email,

      addressone: formData[1].postalAddressOne,
      addresstwo: formData[1].postalAddressTwo,
      city: formData[1].postalAddressCity,
      postcode: formData[1].postalAddressPostCode,
      state: formData[1].postalAddressState.value,
      country: formData[1].postalAddressCountry.value,

      billingaddressone: formData[1].billingAddressOne
        ? formData[1].billingAddressOne
        : formData[1].postalAddressOne,
      billingaddresstwo:
        formData[1].billingAddressOne && formData[1].billingAddressTwo
          ? formData[1].billingAddressTwo
          : formData[1].postalAddressTwo,
      billingcity: formData[1].billingAddressCity
        ? formData[1].billingAddressCity
        : formData[1].postalAddressCity,
      billingpostcode: formData[1].billingAddressPostCode
        ? formData[1].billingAddressPostCode
        : formData[1].postalAddressPostCode,
      billingstate: formData[1].billingAddressState
        ? formData[1].billingAddressState.value
        : formData[1].postalAddressState.value,
      billingcountries: formData[1].billingAddressCountry
        ? formData[1].billingAddressCountry.value
        : formData[1].postalAddressCountry.value,

      driverlicenseloc: formData[2].licenseState.value,
      driverlicensenum: formData[2].licenseNumber,
      expdate: formData[2].licenseExpiration,
      // creditcardtype:       formData[2].creditCardType.value,
      // creditcardnum:        formData[2].creditCardNumber,
      // cardexpdate:          formData[2].creditCardExpiration,
    }

    let search = new URLSearchParams(requestParams)
    const self = this

    axios
      .post('/api/bluechip', search)
      .then(({ data }) => {
        if (data.result.original === 'There was no response from the server') {
          sendResponse({
            success: false,
            data: { content: ['There was no response from the membership service.'] },
          })
          return
        }

        const parsedXml = self.parseXml(data.result.original)

        if (!parsedXml['soap:Envelope']) {
          sendResponse({
            success: false,
            data: { content: ['There was no response from the membership service.'] },
          })
          return
        }

        const { AddCustomerResponse } = parsedXml['soap:Envelope']['soap:Body']

        if (AddCustomerResponse.hasOwnProperty('Success')) {
          sendResponse({
            success: true,
            data: {
              newUserId: AddCustomerResponse.Customer.Profile.LoyaltyMembership.MemberNum,
              content: parsedXml,
            },
          })
        } else if (AddCustomerResponse.hasOwnProperty('Failure')) {
          let errorMessage = null

          if (AddCustomerResponse.Failure.Error.Message.hasOwnProperty('errorText')) {
            errorMessage = Array.isArray(AddCustomerResponse.Failure.Error.Message.errorText)
              ? AddCustomerResponse.Failure.Error.Message.errorText.map(error => error['#text'])
              : [AddCustomerResponse.Failure.Error.Message.errorText['#text']]
          } else if (Array.isArray(AddCustomerResponse.Failure.Error.Message)) {
            errorMessage = AddCustomerResponse.Failure.Error.Message.map(
              message => message['#text'],
            )
          } else {
            errorMessage = [AddCustomerResponse.Failure.Error.Message['#text']]
          }

          sendResponse({
            success: false,
            data: { content: errorMessage },
          })
        } else if (AddCustomerResponse.hasOwnProperty('Fault')) {
          let errorMessage = AddCustomerResponse.Fault.faultstring
            ? AddCustomerResponse.Fault.faultstring.Message
            : 'Unknown API fault.'

          sendResponse({
            success: false,
            data: { content: [errorMessage.replace(/(\'.+\')/g, '')] },
          })
        } else {
          sendResponse({
            success: false,
            data: { content: ['An unknown error occurred. Please try again later.'] },
          })
        }
      })
      .catch(err => {
        sendResponse({
          success: false,
          data: { content: [err] },
        })
      })
  }

  tokenizeCreditCard(formData, sendResponse) {
    axios
      .post('/api/tokenizer', {
        credit_card: formData[2].creditCardNumber,
      })
      .then(data => {
        if (data.paymentCardToken) {
          sendResponse({
            success: true,
            data: {
              paymentCardToken: data.paymentCardToken,
            },
          })
          return
        }
        sendResponse({
          success: false,
          data: {
            error: data,
          },
        })
      })
      .catch(err => {
        sendResponse({
          success: false,
          data: {
            error: err,
          },
        })
      })
  }

  sendEmailSubscription(email, newUserId, firstName, isPromoForm = false) {
    const country = window.location.host.includes('.com.au') === true ? 'en-AU' : 'en-NZ'

    const esubParams = new URLSearchParams({
      email: email,
      loyaltynumber: newUserId,
      firstName: firstName,
      brand: 'thrifty',
      culture: country,
      seg: isPromoForm && promoCode !== '' ? promoCode : 'General',
      hasOptedOutOfEmail: false, // ALWAYS false as implied opt-in used in new T&Cs
      sourceCode: 'General',
      sourceSystem: country === 'en-AU' ? 'thrifty.com.au' : 'thrifty.co.nz',
    })

    axios.post('/esub', esubParams).catch(err => {
      console.error(err)
    })
  }

  parseXml(xml, arrayTags) {
    let dom = null

    if (window.DOMParser) {
      dom = new DOMParser().parseFromString(xml, 'text/xml')
    } else if (window.ActiveXObject) {
      dom = new ActiveXObject('Microsoft.XMLDOM')
      dom.async = false
      if (!dom.loadXML(xml)) throw dom.parseError.reason + ' ' + dom.parseError.srcText
    } else throw new Error('cannot parse xml string!')

    function parseNode(xmlNode, result) {
      if (xmlNode.nodeName == '#text') {
        let v = xmlNode.nodeValue
        if (v.trim()) result['#text'] = v
        return
      }

      let jsonNode = {},
        existing = result[xmlNode.nodeName]

      if (existing) {
        if (!Array.isArray(existing)) result[xmlNode.nodeName] = [existing, jsonNode]
        else result[xmlNode.nodeName].push(jsonNode)
      } else {
        if (arrayTags && arrayTags.indexOf(xmlNode.nodeName) != -1)
          result[xmlNode.nodeName] = [jsonNode]
        else result[xmlNode.nodeName] = jsonNode
      }

      if (xmlNode.attributes)
        for (let attribute of xmlNode.attributes) jsonNode[attribute.nodeName] = attribute.nodeValue

      for (let node of xmlNode.childNodes) parseNode(node, jsonNode)
    }

    let result = {}
    for (let node of dom.childNodes) parseNode(node, result)

    return result
  }
}
